import { useContext, useEffect, useState } from "react";

import "../styles/SiteSpec.css";

import { RestContext } from "../App";
import { DOC_URL } from "../serverConfig";

function SiteSpec({ site }) {
	const [spec, setSpec] = useState(null);

	const { sendGetRequest, sendPostRequest } = useContext(RestContext);

	useEffect(() => {
		if (site?.idNo) {
			sendGetRequest(DOC_URL + "/site/spec/" + site.idNo, (response) => {
				setSpec(response.data);
			});
		}
	}, [site]);

    useEffect(() => {
        console.log(spec);
    }, [spec]);

	const getSpec = () => {
		if (!spec) return null;
		return <iframe title="document-preview-frame" src={DOC_URL + "/preview/" + spec.docId} />;
	};

	return (
		<div id="site-details-spec">
			{getSpec()}
		</div>
	);
}

export default SiteSpec;
